import { computed, isRef, onUnmounted, ref, watch } from "vue";

export function useSlider(maybeItemsRef, { initalIndex = 0 } = { initalIndex: 0 }) {
    const items = isRef(maybeItemsRef) ? maybeItemsRef : ref(maybeItemsRef)

    const activeIndex = ref(initalIndex ?? 0)
    const current = computed(() => items.value.find((value,index) => activeIndex.value === index))

    const direction = ref(0);
    const stopWatchActiveIndex = watch(activeIndex, (index, oldIndex) => {
        if (index > oldIndex) {
            direction.value = 1
        } else if (index < oldIndex) {
            direction.value = -1
        } else {
            direction.value = 0
        }
    })
    onUnmounted(stopWatchActiveIndex)

    function slideNext() {
        activeIndex.value = Math.min(items.value.length - 1, activeIndex.value + 1);
    }

    function slidePrev() {
        activeIndex.value = Math.max(0, activeIndex.value - 1);
    }

    function canNext() {
        return activeIndex.value < items.value.length - 1
    }

    function canPrev() {
        return activeIndex.value > 0
    }


    return {
        activeIndex,
        direction,
        current,
        items,
        canPrev,
        canNext,
        slideNext,
        slidePrev,
    }
}
